<ebw-monorepo-sidebar-header [icon]="'usb_off'" [title]="'map.sidebar.otdr.title'" [isSvg]="false" [isOutline]="false">
</ebw-monorepo-sidebar-header>

<div class="otdr-container">
  <ebw-monorepo-default-otdr-form *appCustomerNot="[customerEnum.Fastweb]"></ebw-monorepo-default-otdr-form>
  <ebw-monorepo-fastweb-otdr-form *appCustomer="[customerEnum.Fastweb]"></ebw-monorepo-fastweb-otdr-form>
</div>
